import React from 'react'
import { Form } from 'react-bootstrap'

import { useTranslationRankmi } from 'helpers/translations.helper'
import { prefix } from '../common'
import { NormativeApplicableInfo } from './NormativeApplicableInfo'
import { NormativeDc3Alert } from './NormativeDc3Alert'
import { TrainingTypeOption } from './TrainingTypeOption'
import {
  Card,
  NormativeDetailsStack,
  NormativeOptionWrapper,
  StyledRadioGroup,
  Title,
} from './styled'

interface TrainingTypeInputProps {
  value: boolean
  onChange: (normative: boolean) => void
  disabled?: boolean
}

export const TrainingTypeInput: React.FC<TrainingTypeInputProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const t = useTranslationRankmi({
    prefix: `${prefix}.trainingType`,
  })

  return (
    <Form.Group className="mb-0">
      <Card>
        <Title>{t('title')}</Title>
        <StyledRadioGroup
          value={value}
          disabled={disabled}
          onChange={(event) => onChange(event.target.value)}
        >
          <TrainingTypeOption
            value={false}
            title={t('general.title')}
            description={t('general.description')}
          />
          <NormativeOptionWrapper>
            <TrainingTypeOption
              value={true}
              title={t('normative.title')}
              description={t('normative.description')}
            />
            {value ? (
              <NormativeDetailsStack>
                <NormativeApplicableInfo />
                <NormativeDc3Alert />
              </NormativeDetailsStack>
            ) : null}
          </NormativeOptionWrapper>
        </StyledRadioGroup>
      </Card>
    </Form.Group>
  )
}
